module.exports = __webpack_public_path__ + "img/rings-2.ed029058.gif";